import React, { useState } from 'react';

function PaymentHistoryTable({ data = [] }) {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 5; // Set the number of rows to display per page

  // Sort function
  const sortedData = [...data].sort((a, b) => {
    if (sortConfig.key) {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];

      if (aValue < bValue) {
        return sortConfig.direction === 'ascending' ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortConfig.direction === 'ascending' ? 1 : -1;
      }
      return 0;
    }
    return 0;
  });


  // Pagination logic
  const totalRows = sortedData.length;
  const totalPages = Math.ceil(totalRows / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const currentRows = sortedData.slice(startIndex, startIndex + rowsPerPage);

  // Function to handle sorting
  const handleSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  return (
    <div className="overflow-x-auto bg-white shadow-md rounded-sm border border-neutral-500">
        
      <h3 className="text-lg font-semibold p-4">Payment History</h3>

      <table className="w-full text-sm text-left rtl:text-right text-gray-700">
        <thead className="text-xs text-gray-900 uppercase  bg-gray-100">
          <tr>
            <th
              onClick={() => handleSort('date')}
              className="px-6 py-4 text-left border-y border-neutral-400 cursor-pointer"
            >
              Date {sortConfig.key === 'date' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
            </th>
            <th
              onClick={() => handleSort('amount')}
              className="px-6 py-4 text-left border-y border-l border-neutral-400 cursor-pointer"
            >
              Amount {sortConfig.key === 'amount' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
            </th>
          </tr>
        </thead>
        <tbody>
        {currentRows.length === 0 ? (
            <tr>
              <td colSpan={2} className="py-4 px-6 text-center">
                No payments found.
              </td>
            </tr>
          ) : (
            currentRows.map((payment, index) => (
              <tr key={index}>
                <td className="px-6 py-4 border-y border-r border-neutral-400">
                  {payment.date?.seconds
                    ? new Date(payment.date.seconds * 1000).toLocaleDateString()
                    : 'Invalid Date'}
                </td>
                <td className="px-6 py-4 border-y border-neutral-400">₹{payment.amount}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>

 {/* Pagination Controls */}
 <nav className="flex items-center justify-between p-4" aria-label="Table navigation">
        <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
          Showing <span className="font-semibold text-gray-900 dark:text-white">
            {(startIndex + 1)}-{Math.min(startIndex + rowsPerPage, totalRows)}
          </span> of <span className="font-semibold text-gray-900 dark:text-white">{totalRows}</span>
        </span>
        <ul className="inline-flex -space-x-px text-sm h-8">
          <li>
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className="flex items-center justify-center px-3 h-8 ms-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
            >
              Previous
            </button>
          </li>
          {[...Array(totalPages)].map((_, index) => (
            <li key={index}>
              <button
                onClick={() => setCurrentPage(index + 1)}
                className={`flex items-center justify-center px-3 h-8 leading-tight ${
                  currentPage === index + 1
                    ? 'text-blue-600 bg-blue-50 hover:bg-blue-100 hover:text-blue-700 border  border-gray-300 ' 
                    : 'text-gray-500 bg-white hover:bg-gray-100 hover:text-gray-700 border  border-gray-300  dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white'
                }`}
              >
                {index + 1}
              </button>
            </li>
          ))}
          <li>
            <button
              onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
              className="flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
            >
              Next
            </button>
          </li>
        </ul>
      </nav>

    </div>
  );
}

export default PaymentHistoryTable;